import React, { FC } from "react";
import styled from "@emotion/styled";
import { Button, Dialog } from "@radix-ui/themes";
import Lowlight from "react-lowlight";
import { SessionEventSummarySchema } from "@/domains/openapi/types";
import { TERMINAL_FONT_FAMILY } from "./shared/constants";

interface RawEventsModalProps {
  isOpen: boolean;
  onClose: () => void;
  events: SessionEventSummarySchema[];
}

export const RawEventsModal: FC<RawEventsModalProps> = ({ isOpen, onClose, events }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Content style={{ maxWidth: "800px", maxHeight: "80vh" }}>
        <DialogTitle>Raw Session Events (JSON)</DialogTitle>
        <DialogDescription size="2" mb="4">
          All session events including hidden ones, displayed as raw JSON data.
        </DialogDescription>

        <JsonContainer>
          <Lowlight language="json" value={JSON.stringify(events, null, 2)} markers={[]} />
        </JsonContainer>

        <ActionButtons>
          <Button onClick={onClose}>Close</Button>
        </ActionButtons>
      </Dialog.Content>
    </Dialog.Root>
  );
};

const DialogTitle = styled(Dialog.Title)`
  font-family: ${TERMINAL_FONT_FAMILY};
  font-size: 13px;
  font-weight: 600;
`;

const DialogDescription = styled(Dialog.Description)`
  font-family: ${TERMINAL_FONT_FAMILY};
  font-size: 13px;
`;

const JsonContainer = styled.div`
  max-height: 500px;
  overflow: auto;
  border: 1px solid var(--gray-6);
  padding: 12px;
  background-color: var(--gray-1);

  & pre {
    margin: 0;
    font-size: 13px;
    font-family: ${TERMINAL_FONT_FAMILY};

    & code {
      background-color: transparent;
    }
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;
